require("@fancyapps/fancybox");
require('./_functions');
require('./_resize');
require('./common');
require('./modal');
require('./filters');
require('./starrr.js');
require('./slider.js');
require('./checkout');
require('./product');
